var exports = {
  "Qs": "xe7b6e3d6--4c4a7a--content",
  "VA": "xe7b6e3d6--4c4a7a--subtitle",
  "Qq": "xe7b6e3d6--4c4a7a--text",
  "NQ": "xe7b6e3d6--4c4a7a--features-list",
  "N4": "xe7b6e3d6--4c4a7a--feature",
  "h_": "xe7b6e3d6--4c4a7a--description",
  "e4": "xe7b6e3d6--4c4a7a--banks",
  "NS": "xe7b6e3d6--4c4a7a--author-description",
  "VZ": "xe7b6e3d6--4c4a7a--banks-list",
  "pK": "xe7b6e3d6--4c4a7a--bank-item",
  "T6": "xe7b6e3d6--4c4a7a--banks-title",
};

module.exports = exports;
